export const CREATE_INTERNAL_ATTACHMENT = "CREATE_INTERNAL_ATTACHMENT";
export const CREATE_MANUFACTURER_ATTACHMENT = "CREATE_MANUFACTURER_ATTACHMENT";

export const CreateInternalAttachment = (data) => {
  return {
    type: CREATE_INTERNAL_ATTACHMENT,
    payload:data
  };
};

export const CreateManufacturerAttachment = (data) => {
  return {
    type: CREATE_MANUFACTURER_ATTACHMENT,
    payload:data

  };
}
